import { compiledPaths } from '@app/paths';
import { useAmplitude, useEffectOnce } from '@app/utils/hooks';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export const LookbookProductDetailsPage = () => {
  const { lookbookId, productId } = useParams();
  const [searchParams] = useSearchParams();
  const { trackEvent } = useAmplitude();

  useEffectOnce(() => {
    trackEvent({ name: 'lookbookPage.product.opened' });
  });

  const searchParamsObject = Object.fromEntries(searchParams.entries());
  const updatedSearchParams = new URLSearchParams({
    ...searchParamsObject,
    ...(productId ? { product: productId } : {}),
  });

  return (
    <Navigate
      to={{
        pathname: compiledPaths.LOOKBOOK_SINGLE({ lookbookId }),
        search: updatedSearchParams.toString(),
      }}
      replace
    />
  );
};
